import { addDays, format, getDay } from 'date-fns'

/**
 * 函式參數：日期範圍與排除規則。
 */
export interface GetDeliveryDateRangeOptions {
  /**
   * 起始日期 (含)。
   * 預設為目前時間。
   */
  startDate?: Date

  /**
   * 從 `startDate` 起可以往後選擇的最大天數，預設 365。
   */
  maxSelectableDeliveryDays?: number

  /**
   * 「不可配送日」的字串陣列，格式 `YYYY-MM-DD`。
   */
  blockoutDeliveryDays?: string[]

  /**
   * 「不可配送星期」，0 ~ 6 代表 Sun ~ Sat。
   */
  excludeDays?: number[]
}

/**
 * 函式回傳：`ReactDatePicker` 需要的資料結構。
 */
export interface DeliveryDateRange {
  minDate: Date
  maxDate: Date
  filterDate: (date: Date) => boolean
}

/**
 * 依據傳入規則產生日期範圍及過濾器。
 */
export function getDeliveryDateRange({
  startDate = new Date(),
  maxSelectableDeliveryDays = 365,
  blockoutDeliveryDays = [],
  excludeDays = [],
}: GetDeliveryDateRangeOptions = {}): DeliveryDateRange {
  // ------ 基本範圍 ------
  const minDate = startDate
  // NOTE: 減 1 是因為 minDate 也要算在 maxSelectableDeliveryDays 內
  const maxDate = addDays(minDate, maxSelectableDeliveryDays - 1)

  // ------ 排除條件 ------
  const blockedDateSet = new Set(blockoutDeliveryDays)
  const excludedWeekdaySet = new Set<number>(excludeDays)

  const filterDate = (date: Date): boolean => {
    // 1. 排除「不可配送日」
    const dateString = format(date, 'yyyy-MM-dd')
    if (blockedDateSet.has(dateString)) return false

    // 2. 排除「不可配送星期」
    if (excludedWeekdaySet.has(getDay(date))) return false

    // 3. 排除「最大最小日期範圍以外」
    if (date < minDate || date > maxDate) return false

    return true
  }

  return {
    minDate,
    maxDate,
    filterDate,
  }
}
